"use strict";
/** @jsxRuntime classic */
/** @jsx jsx */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Webshop = void 0;
var theme_ui_1 = require("theme-ui");
var Footer_1 = require("../../organisms/Footer/Footer");
var WebshopHeader_1 = require("../../organisms/WebshopHeader/WebshopHeader");
var Webshop = function (_a) {
    var children = _a.children, profileComponent = _a.profileComponent, menuItems = _a.menuItems;
    return (theme_ui_1.jsx(theme_ui_1.Box, null,
        theme_ui_1.jsx(WebshopHeader_1.WebshopHeader, { menuItems: menuItems, profileComponent: profileComponent }),
        children,
        theme_ui_1.jsx(Footer_1.Footer, null)));
};
exports.Webshop = Webshop;
